import { formatCents } from '../lib/format.ts'

/**
 * US-12's balance box: drinks, fees, and credits itemized separately, then the
 * total. Every row renders even at zero, so the member can see what the total
 * is made of.
 *
 * The total is shown from *unapplied* credit and is the same number credit
 * application would produce: consuming credit reduces the open charges and the
 * unused credit by the same amount, so (D + F − S) − (C − S) = D + F − C.
 */
export function BalanceCard({
  drinksTotal,
  feesTotal,
  creditTotal,
}: {
  drinksTotal: number
  feesTotal: number
  creditTotal: number
}) {
  const balance = drinksTotal + feesTotal - creditTotal
  const label = balance > 0 ? 'Balance owing' : balance < 0 ? 'In credit' : 'Settled'
  const tone = balance > 0 ? 'owing' : balance < 0 ? 'credit' : ''

  return (
    <div className="card">
      <div className="balance-rows">
        <div className="balance-row">
          <span className="label">Unpaid drinks</span>
          <span>{formatCents(drinksTotal)}</span>
        </div>
        <div className="balance-row">
          <span className="label">Unpaid fees</span>
          <span>{formatCents(feesTotal)}</span>
        </div>
        <div className="balance-row">
          <span className="label">Credit</span>
          <span>{creditTotal > 0 ? `-${formatCents(creditTotal)}` : formatCents(0)}</span>
        </div>
        <div className="balance-row balance-row--total">
          <span>{label}</span>
          <span className={`amount ${tone}`}>{formatCents(Math.abs(balance))}</span>
        </div>
      </div>
    </div>
  )
}
